import { render, staticRenderFns } from "./Objetivos.vue?vue&type=template&id=37645702&"
import script from "./Objetivos.vue?vue&type=script&lang=js&"
export * from "./Objetivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports